import { render, staticRenderFns } from "./PolicyHolderFinalizeCancel.vue?vue&type=template&id=6ce591b3&scoped=true&"
import script from "./PolicyHolderFinalizeCancel.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderFinalizeCancel.vue?vue&type=script&lang=js&"
import style0 from "./PolicyHolderFinalizeCancel.vue?vue&type=style&index=0&id=6ce591b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce591b3",
  null
  
)

export default component.exports